export enum BUTTON_COLOR_TYPES {
  dark = "black",
  white = "outline",
  blue = "primary"
}
